/* eslint-disable max-len */
import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';
import styles from 'src/styles/common/templateGallery.module.scss';

export const TemplateGallerySetupTitleIcon: FC<CommonIconProps> = ({ className }) => (
  <div className={styles.headerTitleIconContainer}>
    <svg
      className={className}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2243_10126)">
        <rect width="56" height="56" rx="28" fill="#272756" />
        <g clipPath="url(#clip1_2243_10126)">
          <path
            d="M24.2661 30.4605C24.8404 30.0851 25.0392 29.8863 24.8846 29.3562C24.7079 28.8261 24.5091 28.6936 23.736 28.782L10.6607 30.1955C9.86558 30.2838 9.49011 30.3059 9.31341 30.5931C9.13672 30.8581 9.24715 31.2336 9.49011 31.9845L10.8595 36.2473C11.1024 36.9982 11.235 37.3516 11.5221 37.4841C11.8092 37.6166 12.1626 37.4179 12.8473 37.0203L24.2661 30.4605Z"
            fill="#CDF378"
          />
          <path
            d="M24.2663 26.463C24.9068 26.728 25.1939 26.7722 25.5252 26.3084C25.8565 25.8666 25.8345 25.6237 25.3044 25.0494L16.4476 15.3313C15.9175 14.7349 15.6525 14.4478 15.3212 14.4699C14.9899 14.492 14.769 14.8012 14.3052 15.4417L11.6769 19.0418C11.2131 19.6823 10.9922 19.9916 11.0805 20.3008C11.1689 20.61 11.5223 20.7867 12.229 21.0959L24.2663 26.463Z"
            fill="#CDF378"
          />
          <path
            d="M27.513 24.1217C27.6897 24.8064 27.8222 25.0493 28.3744 25.0493C28.9266 25.0493 29.1033 24.8947 29.28 24.1217L31.9304 11.223C32.085 10.45 32.1733 10.0745 31.9746 9.80948C31.7758 9.56653 31.3782 9.56653 30.5831 9.56653H26.1216C25.3485 9.56653 24.951 9.56653 24.7522 9.83157C24.5534 10.0745 24.6197 10.4721 24.7964 11.2451L27.513 24.1217Z"
            fill="#CDF378"
          />
          <path
            d="M31.312 25.3585C30.8703 25.8886 30.7377 26.1537 31.069 26.5954C31.4003 27.0371 31.6212 27.1034 32.3501 26.7721L44.3211 21.3387C45.0499 21.0295 45.3812 20.8528 45.4917 20.5436C45.58 20.2344 45.3591 19.9031 44.8953 19.2847L42.2449 15.6625C41.7811 15.044 41.5602 14.7127 41.2289 14.7127C40.8976 14.6906 40.6326 14.9778 40.1025 15.5741L31.312 25.3585Z"
            fill="#CDF378"
          />
          <path
            d="M32.5487 29.1354C31.864 29.0912 31.5769 29.1575 31.4002 29.6655C31.2235 30.1956 31.3339 30.4164 31.9965 30.814L43.4595 37.2854C44.1442 37.683 44.4755 37.8817 44.7847 37.7492C45.094 37.6388 45.2044 37.2633 45.4473 36.5124L46.8167 32.2717C47.0597 31.5208 47.1701 31.1674 46.9934 30.8802C46.8167 30.6152 46.4192 30.571 45.6461 30.4827L32.5487 29.1354Z"
            fill="#CDF378"
          />
          <path
            d="M30.2074 32.3822C29.8319 31.808 29.6331 31.6092 29.103 31.7638C28.573 31.9405 28.4404 32.1393 28.5288 32.9123L30.0307 45.9877C30.119 46.7828 30.1632 47.1583 30.4282 47.335C30.6933 47.5117 31.0688 47.3791 31.8197 47.1583L36.0603 45.7668C36.8113 45.5238 37.1647 45.3913 37.2751 45.1042C37.3856 44.795 37.1868 44.4637 36.7892 43.779L30.2074 32.3822Z"
            fill="#CDF378"
          />
          <path
            d="M4.60879 72.1382C1.95839 70.791 2.04673 69.267 3.50446 66.8374C10.2851 56.0591 19.1639 42.0782 24.6635 33.3098C25.1053 32.6251 26.563 33.1773 26.32 34.0387C21.8585 43.5139 14.9233 58.4445 9.53413 70.1063C8.18684 72.8229 7.10459 73.3751 4.60879 72.1382Z"
            fill="#CDF378"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2243_10126">
          <rect width="56" height="56" rx="28" fill="white" />
        </clipPath>
        <clipPath id="clip1_2243_10126">
          <rect width="44.6152" height="63.3889" fill="white" transform="translate(2.48877 9.56659)" />
        </clipPath>
      </defs>
    </svg>
  </div>
);
